<template>
  <div class="recharge">
    <div class="level_box">
      <p class="label">充值金额</p>
      <div class="level_goodslist">
        ￥
        <input type="number" v-model="price" disabled v-if="entrance=='gorecharge'" />
        <input type="number" v-model="price" @input="change(price)" v-if="entrance=='balance'" />
      </div>
    </div>

    <div class="level_paytype">
      <p class="label">支付方式</p>
      <div class="paytype_checkbox">
        <van-checkbox v-model="pt_checked" checked-color="#45B9BC">
          <span class="iconfont icon-weixinzhifu"></span>微信支付
        </van-checkbox>
      </div>
    </div>

    <!-- <div class="agreement flex_center">
      <van-icon name="passed" color="#45B9BC" size="15" />
      <span>充值即同意</span>
      <span><router-link :to="{path: 'tech_agreement',query:{type:1}}">《平台股东协议》</router-link></span>
    </div> -->

    <div style="width:100%;margin:3rem 0;text-align:center;">
      <button class="check_btn" @click="rechange">确认充值</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "recharge",
  components: {},
  data() {
    return {
      pt_checked: true,
      price: 199.0,
      entrance: "gorecharge"
    };
  },
  created() {
    if (this.$route.query.entrance) {
      this.entrance = this.$route.query.entrance;
      this.price = 0;
    }
  },
  methods: {
    level_check(id) {
      this.level_checked = id;
    },
    rechange() {
      //充值余额
      var that = this;
      if (this.entrance == "balance") {

        var reg = /(^([-]?)[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^([-]?)(0){1}$)|(^([-]?)[0-9]\.[0-9]([0-9])?$)/
		     //验证警戒值
		    if(this.price!='' && this.price != undefined){
		    	if (!reg.test(this.price)) {
		        this.$message({
		            message: '请输入正确充值金额！',
		            type: 'error'
		        })
		        this.price='';
		        /*this.$refs.warn_value.focus();*/
		        return ;
          }
        }

        if (this.price <= 0) {
          return;
        }
        this.axios({
          url: this.api.member.create_recharge_order,
          data: { price: this.price }
        }).then(res => {
          console.log(res);
          //调用微信支付
          this.wx.wxPay(
            {
              url: this.api.wxpay.rechange_balance,
              data: {
                id: res.shares_id,
                sharessn: res.sharessn
              }
            },
            () => {
              that.$toast({
                message: "充值成功",
                duration: 1000,
                onClose: function() {
                  that.$router.push("/balance");
                }
              });
            }
          );
        });
      }
      //购买199成为分享合伙人
      if (this.entrance == "gorecharge") {
        this.axios({
          url: this.api.member.create_commission_order,
          data: {}
        }).then(res => {
          //调用微信支付
          this.wx.wxPay(
            {
              url: this.api.wxpay.rechange_commission,
              data: {
                id: res.shares_id,
                sharessn: res.sharessn
              }
            },
            () => {
              that.$toast({
                message: "支付成功",
                duration: 1000,
                onClose: function() {
                  that.$router.push("/commission_qrcode");
                }
              });
            }
          );
        });
      }
    },
    change(val) {
      val = val.replace(/(^\s*)|(\s*$)/g, "");
      if (!val) {
        this.a = "";
        return;
      }
      var reg = /[^\d.]/g;

      // 只能是数字和小数点，不能是其他输入
      val = val.replace(reg, "");

      // 保证第一位只能是数字，不能是点
      val = val.replace(/^\./g, "");
      // 小数只能出现1位
      val = val
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      // 小数点后面保留2位
      val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");

      this.a = val;
    }
  }
};
</script>
<style scoped>
.recharge {
  font-size: 0.75rem;
  color: #595959;
}

.label {
  background-color: white;
  padding: 0.6rem 0.75rem;
  border-bottom: 1px solid #eee;
}
.level_goodslist {
  font-size: 0.7rem;
  color: #363434;
  padding: 1.3rem 1rem;
  background-color: white;
  font-weight: bold;
}
.level_goodslist input {
  font-size: 1rem;
}
.level_checked {
  background-image: linear-gradient(to bottom right, #9ad4d6, #45b9bc);
  border: 1px solid #f2f2f2 !important;
  color: #f2f2f2 !important;
}
.level_tip,
.level_paytype {
  margin-top: 0.5rem;
  background-color: white;
}
.level_tip ul {
  padding: 0.3rem 0.75rem;
}
.level_tip li {
  padding: 0.3rem 0;
  font-size: 0.6rem;
  color: #8f8e8e;
}
.paytype_checkbox {
  padding: 0.75rem;
}
.icon-weixinzhifu {
  color: rgb(9, 187, 7);
  font-size: 1.5rem;
  line-height: 30px;
}
.van-checkbox__label {
  line-height: auto !important;
  margin-left: 1rem !important;
}
.check_btn {
  color: #ffffff;
  background-color: #45b9bc;
  border-radius: 4px;
  font-size: 1rem;
  padding: 0.5rem 0;
  width: 75%;
}
.level_tip li span {
  font-size: 0.6rem;
  color: #45b9bc;
}
.agreement {
  font-size: 0.6rem;
  color: #787776;
  padding: 0.4rem 0.7rem;
}
.agreement span:last-child {
  color: #45b9bc;
}
</style>



// WEBPACK FOOTER //
// src/views/center/recharge.vue